import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/home',
            component: () => import('./layout/Layout'),
            children: [
                {
                    path: '/home',
                    name: 'Home',
                    component: () => import('./views/Home'),
                },
                {
                    path: '/introduce', // 公司概况
                    name: 'CompanyIntroduce',
                    component: () => import('./views/CompanyIntroduce'),
                },
                {
                    path: '/introduceDetail', // 公司概况详情
                    name: 'CompanyIntroduceDetail',
                    component: () => import('./views/CompanyIntroduce/detail'),
                },
                {
                    path: '/news', // 公司资讯
                    name: 'CompanyNews',
                    component: () => import('./views/CompanyNews'),
                },
                {
                    path: '/newsDetail', // 公司资讯详情
                    name: 'CompanyNewsDetail',
                    component: () => import('./views/CompanyNews/detail'),
                },
                {
                    path: '/layout', // 产业布局
                    name: 'CompanyLayout',
                    component: () => import('./views/CompanyLayout'),
                },
                {
                    path: '/layoutDetail', // 产业布局详情
                    name: 'CompanyLayoutDetail',
                    component: () => import('./views/CompanyLayout/detail'),
                },
                {
                    path: '/work', // 党群工作
                    name: 'PartyWork',
                    component: () => import('./views/PartyWork'),
                },
                {
                    path: '/workDetail', // 党群工作详情
                    name: 'PartyWorkDetail',
                    component: () => import('./views/PartyWork/detail'),
                },
                {
                    path: '/activity', // 专题活动
                    name: 'SpecialActivity',
                    component: () => import('./views/SpecialActivity'),
                },
                {
                    path: '/activityDetail', // 专题活动详情
                    name: 'SpecialActivityDetail',
                    component: () => import('./views/SpecialActivity/detail'),
                },
                {
                    path: '/guide', // 办事指南
                    name: 'BusinessGuide',
                    component: () => import('./views/BusinessGuide'),
                },
                {
                    path: '/guideDetail', // 办事指南详情
                    name: 'BusinessGuideDetail',
                    component: () => import('./views/BusinessGuide/detail'),
                },
                {
                    path: '/search', // 全站搜索
                    name: 'Search',
                    component: () => import('./views/Search'),
                },
                {
                    path: '/searchDetail', // 全站搜索详情
                    name: 'SearchDetail',
                    component: () => import('./views/Search/detail'),
                },
            ],
        },
        {
            path: '*',
            redirect: '/home',
        },
    ],

});
